<template>
  <div class="view box grow">
    <page-headers
      :header="'Detections'"
      :breadcrumbs="breadcrumbs"
      :is-border="true"
      :documentation="'page-detections'"
      class="box"
    >
    </page-headers>
    <div class="full-height" v-loading="isIocDetectionsLoading || isLoading">
      <div class="table-toolbar" v-if="accountKeyIocsReqStatus === 'saved'">
        <div slot="iocTacticList">
          <h3 style="margin-bottom:12px;">
            <span class="mitre-attack-header">MITRE ATT&CK and Cloud tactics </span>
          </h3>
          <div class="ioc-tactic-list">
            <div @click="intersection(rec.title)" v-for="(rec, i) in tacticRecords" :key="i">
              <div v-if="rec.value !== 0"
                :class="selectedMitreAttack === rec.title ? 
                (workloadCheck ? 'tactic-records-container-highligted-workload' 
                : (cloudControlCheck ? 'tactic-records-container-highligted-cloudControl'
                :'tactic-records-container-highligted')):'tactic-records-container'"
              >
                <div class="tact-records-title">{{ rec.title }}</div>
                <div
                  class="tactic-records-value"
                  :style="{'color': workloadCheck? '#2DCB8B': (cloudControlCheck? '#B264DE' : '#1A90FA')}"
                >{{ rec.value }}</div>
              </div>
            </div>
          </div>
        </div>
        <table-toolbar
          :key="detectionsData.key"
          :search-properties="visibleDetectionsColumns"
          :total-search-properties="detectionsColumns"
          :search-data="detectionsData"
          :initial-tags="detectionsData.searchTags"
          :reload-component="detectionsData.reloadToolbar"
          @update-querydata="updateTableQueryData"
          @refresh-tabledata="refreshTableData"
          @update-columns-data="modifyColumnsData"
        >
          <div slot="left-toolbar-tools" class="filter-button-group">
            <el-button size="small" round @click="allRec(), currentIoc='', toggleCheck = !toggleCheck" :style="{'background-color': (!workloadCheck && !cloudControlCheck) ? '#1377f0': '#FFFFFF'}">
              <span :style="{'color': (!workloadCheck && !cloudControlCheck) ? '#FFFFFF': '#606266'}">All</span>
            </el-button>
            <el-button size="small" round @click="workloadList(), currentIoc='', toggleCheck = !toggleCheck"
              :style="{'background-color': workloadCheck? '#2DCB8B': '#FFFFFF'}"
            >
              <span :style="{'color': workloadCheck? '#FFFFFF': '#606266'}">Workloads</span>
            </el-button>
            <el-button size="small" round @click="cloudControlList(), currentIoc='', toggleCheck = !toggleCheck"
              :style="{'background-color': cloudControlCheck? '#B264DE': '#FFFFFF'}"
            >
              <span :style="{'color': cloudControlCheck? '#FFFFFF': '#606266'}">Cloud Control Plane</span>
            </el-button>
            <el-divider direction="vertical"></el-divider>
          </div>
          <div slot="local-helper" class="search-reset">
            <div class="grid-content helper-message">
              <p v-if="$route.query.accountKey">
                Showing detections for {{ $route.query.nickName || $route.query.accountKey }}
              </p>
              <p v-else-if="$route.query.integrationType">
                Showing detections for {{ getIntegrationAccountTitle($route.query.integrationType) }} Integration
              </p>
              <p v-else>Showing detections for Integration Accounts</p>
              <el-button type="text" class="icon-text-button" @click="gotoParentPage">
                <i class="material-icons c-icon"></i><span>Reset</span>
              </el-button>
            </div>
          </div>
        </table-toolbar>
      </div>

      <action-table-element
        v-if="accountKeyIocsReqStatus === 'saved'"
        :columns="visibleDetectionsColumns"
        :table-data="detectionsData"
        :actions="tableActions"
        :height-offset="320"
        ref="basicTable"
        @update-record-count="recordCountHandler"
      ></action-table-element>

      <aside-sidebar
        v-if="agentListReqStatus === 'saved'"
        parent=".layout-container"
        sibling=".host-table"
        v-model="hideProcessLineageAside"
        :class="{ 'process-lineage-details': !hideProcessLineageAside }"
      >
        <div slot="title" class="aside-ioc-title">
          <div class="flex gaps align-baseline">
            <div class="box"><i class="fal fa-exclamation-circle"></i></div>
            <div class="box flex column">
              <div class="box flex gaps align-baseline">
                <span class="box grow" v-if="!$_.isEmpty(detectionSelected.iocSummary)">
                  <h2>{{ detectionSelected.iocSummary }}</h2>
                </span>
              </div>
              <div class="box">
                <time class="caption1">{{ $moment(detectionSelected.seenTime).format('MM/DD/YY hh:mm:ss A') }}</time>
                <div class="box" v-if="detectionSelected.trailId">
                  <span class="caption1 cursor-pointer local-trailid" @click="gotoThreatHunting">
                    Local Trail ID: {{ detectionSelected.trailId }}
                    <span class="material-icons" v-show="insightsEnabled"> search </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="box score">
              <span class="score body1">+{{ detectionSelected.scoreContribution }}</span>
            </div>
          </div>
        </div>
        <process-lineage-graph
          slot="content"
          :ioc="detectionSelected"
          :key="detectionSelected.iocHash"
        ></process-lineage-graph>
      </aside-sidebar>
      <aside-sidebar
        id="ioc-details-feed"
        parent=".layout-container"
        sibling=".host-table"
        :feed-loading="isIocDetailsLoading"
        v-model="hideIoCDetails"
        ref="iocDetailsAside"
      >
        <div slot="title" class="aside-ioc-title">
          <div class="flex gaps align-baseline">
            <div class="box"><i class="fal fa-exclamation-circle"></i></div>
            <div class="box grow flex column">
              <div class="box flex gaps align-baseline">
                <span class="box grow" v-if="!$_.isEmpty(detectionSelected.iocSummary)">
                  <h2>{{ detectionSelected.iocSummary }}</h2>
                </span>
              </div>
              <div class="box">
                <time class="caption1">{{ $moment(detectionSelected.seenTime).format('MM/DD/YY hh:mm:ss A') }}</time>
              </div>
              <div class="box" v-if="detectionSelected.trailId">
                <span class="caption1 cursor-pointer local-trailid" @click="gotoThreatHunting">
                  Local Trail ID: {{ detectionSelected.trailId }}
                  <span class="material-icons" v-show="insightsEnabled"> search </span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <ioc-multi-event-details slot="content" :ioc-details="detectionSelected"></ioc-multi-event-details>
      </aside-sidebar>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import { mapGetters } from 'vuex'
import PageHeaders from '@/components/layout/PageHeaders.vue'
import TableToolbar from '@/components/table/TableToolbar.vue'
import ActionTableElement from '@/components/table/ActionTableElement.vue'
import AsideSidebar from '@/components/layout/AsideSidebar.vue'
import ProcessLineageGraph from '@/components/graph/ProcessLineageGraph.vue'
import IocMultiEventDetails from '@/components/feed/ioc-details/IocMultiEventDetails.vue'

import { getUserFriendlyTrailLabel } from '@/utilities/trail.helper'
import { iocDetectionsMetaInfo } from '@/column-header/detections/ioc-detections-meta'

import { MITRE_TACTIC_LIST_REQ, MITRE_TECHNIQUE_LIST_REQ } from '@/store/modules/mitre-attack/mitre-attack.type'
import {
  ACCOUNT_KEY_IOCS_REQ,
  ACCOUNT_KEY_IOCS_SUCCESS,
  MULTIPLE_ACCOUNT_KEY_IOCS_REQ,
  IOC_DETAILS_REQ,
  IOC_DETAILS_SUCCESS,
  DETECTIONS_VIEW_PREFERENCES_REQ,
  SAVE_DETECTIONS_VIEW_PREFERENCES
} from '@/store/modules/detections/detections.type'
import { RULES_LIST_REQ, RULES_LIST_SUCCESS } from '@/store/modules/rules/rules.type'
import { AGENT_LIST_REQ } from '@/store/modules/agents/agents.type'
import { PREFERENCE_STORE_REQ } from '@/store/modules/column-preference/column-preference.type'

export default {
  name: 'AccountKeyDetections',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  data () {
    return {
      helperMessage: 'Help Message Here',
      detectionColumnPrefs: {},
      tableName: "Detections",
      tblId: 6,
      breadcrumbs: this.threatBreadCrumb,
      visibleDetectionsColumns: [],
      detectionsColumns: iocDetectionsMetaInfo.meta.columns,
      prevRoute: {},
      detectionsData: {},
      detectionSelected: {
        iocSummary: {},
        iocEventsList: {},
        agentDetails: {}
      },
      isLoading: false,
      hideProcessLineageAside: true,
      hideIoCDetails: true,
      tableActions: [
        {
          name: 'ioc_details',
          icon: 'material-icons c-icon',
          iconSubject: 'info',
          tooltip: 'Detection Details',
          rbac: {
            subject: 'cyber_attacks',
            operation: 'read'
          },
          actionHandler: selection => {
            this.openIocDetailsAside(selection.row)
          }
        },
        {
          name: 'process_lineage',
          icon: 'material-icons c-icon',
          iconSubject: 'device_hub',
          tooltip: 'Process Lineage',
          rbac: {
            subject: 'cyber_attacks',
            operation: 'read'
          },
          actionHandler: selection => {
            this.openProcessLineageAside(selection.row)
          }
        }
      ],
      workloadCheck: false,
      cloudControlCheck: false,
      mitreAttackDetailsforTopHeader: {},
      tacticRecords: [],
      selectedMitreAttack: '',
      currentSelectedMitreAttack: '',
      toggleCheck: false, // // for handling KPI deselect functionality
      currentIoc: '' // for handling KPI deselect functionality
    }
  },
  created () {
    let tableMetaData = {
      activePage: 1,
      searchTags: []
    }

    if (this.mitreTacticListReqStatus !== 'saved') {
      this.$store.dispatch(MITRE_TACTIC_LIST_REQ).then(() => {
        this.$store.dispatch(MITRE_TECHNIQUE_LIST_REQ).then(() => {
          this.callApi(tableMetaData)
        })
      })
    } else {
      this.callApi(tableMetaData)
    }
    this.loadDetectionColumnPreferences()
  },
  methods: {
    gotoThreatHunting () {
      if (!this.insightsEnabled) {
        return false
      }
      let startTimeHrBefore = moment(this.detectionSelected.seenTime).subtract({ hours: 1 })
      let startTimeHrAfter = moment(this.detectionSelected.seenTime).add({ hours: 1 })

      let threatHuntParam = `start_time:${startTimeHrBefore.toISOString()}+end_time:${startTimeHrAfter.toISOString()}+edgeName:in:exec:file:network:system:user+trailId:eq:${
        this.detectionSelected.trailId
      }+agentId:eq:${this.detectionSelected.agentId}`
      this.$router.push({
        name: 'threat-hunting',
        query: { search: threatHuntParam }
      })
    },
    gotoParentPage () {
      this.$router.push(this.breadcrumbs[1].to)
    },
    getFriendlyTrailLabel (val) {
      return getUserFriendlyTrailLabel(val)
    },
    openProcessLineageAside (row) {
      this.detectionSelected = row
      this.hideProcessLineageAside = false
    },
    openIocDetailsAside (row) {
      this.detectionSelected = row
      if (_.isEmpty(this.detectionSelected.agentDetails)) {
        this.detectionSelected.agentDetails = this.detectionSelected.host
      }
      if (_.isEmpty(this.detectionSelected.iocEventsList)) {
        this.$store.dispatch(IOC_DETAILS_REQ, row.getIocDetailsHashId()).then(details => {
          this.$set(this.detectionSelected, 'iocEventsList', details.iocEventsList)
          this.$store.dispatch(IOC_DETAILS_SUCCESS)
        })
      }
      this.hideIoCDetails = false
    },
    updateTableQueryData () {
      // Prevent from going to parent page
      // if (_.isEmpty(this.detectionsData.searchTags)) {
      //   this.gotoParentPage() 
      // }
      if (this.$refs.basicTable) {
        this.$refs.basicTable.updateTableData()
      }
    },
    recordCountHandler () {
      // key is used to re-render TableToolbar component
      // on page change to update 'queryCountText'
      this.detectionsData.key = !this.detectionsData.key
      this.detectionsData.reloadToolbar = false
    },
    modifyColumnsData (selectedColumns) {
      this.detectionColumnPrefs.userId = this.userProfile.id;
      this.detectionColumnPrefs.tblName = this.tableName;
      this.detectionColumnPrefs.preferedCols = selectedColumns.length === 0? NaN: selectedColumns;
      this.detectionColumnPrefs.tblId = 6;

      this.visibleDetectionsColumns = this.detectionsData.updateVisibleColumns(this.detectionsColumns, selectedColumns)
      
      this.$store.dispatch(SAVE_DETECTIONS_VIEW_PREFERENCES, this.detectionColumnPrefs).then(
        data => {
          // store preferences in vuex
          this.detectionColumnPrefs.preferedCols = this.visibleDetectionsColumns;
          this.$store.dispatch(PREFERENCE_STORE_REQ, this.detectionColumnPrefs);
        })
    },
    refreshTableData (tableMetaData) {
      this.callApi(tableMetaData)
    },
    loadDetectionColumnPreferences() {
      // check if already present in store
      if (_.has(this.userPref, this.userProfile.id) && _.has(this.userPref[this.userProfile.id], this.tableName)) {
        //  read values from store
        this.visibleDetectionsColumns = this.userPref[this.userProfile.id][this.tableName]
        // this.updateStoreWithPrefs()
      } else {
        // fetch from database
        this.$store.dispatch(DETECTIONS_VIEW_PREFERENCES_REQ, this.userProfile.id)
          .then(data => {
            this.visibleDetectionsColumns = this.detectionsColumns.filter(col => {
              return this.detectionPreferences.includes(col.label)
            })
            this.updateStoreWithPrefs()
          })
      }
    },
    updateStoreWithPrefs () {
      this.detectionColumnPrefs = {
        userId: this.userProfile.id,
        tblName: this.tableName,
        preferedCols: this.visibleDetectionsColumns
      }

      this.$store.dispatch(PREFERENCE_STORE_REQ, this.detectionColumnPrefs);
    },
    getDetectionByAlertAccountKey (tableMetaData) {
      let type = this.$route.query.integrationType.toUpperCase()
      this.$store
        .dispatch(ACCOUNT_KEY_IOCS_REQ, {
          integrationType: type
        })
        .then(detections => {
          this.detectionsData = detections
          this.$store.dispatch(RULES_LIST_SUCCESS)
          this.$store.dispatch(ACCOUNT_KEY_IOCS_SUCCESS)
          this.setTableMetaData(tableMetaData)
          this.isLoading = false
          this.tacticRecordsHandler(this.detectionsData.models)
          if (this.workloadCheck) {
            this.workloadList()
          } else if (this.cloudControlCheck) {
            this.cloudControlList()
          } else {
            this.allRec()
          }
        })
    },
    getDetectionByAccountKey (tableMetaData) {
      this.$store
        .dispatch(ACCOUNT_KEY_IOCS_REQ, {
          accountKey: this.$route.query.accountKey
        })
        .then(detections => {
          this.detectionsData = detections
          this.$store.dispatch(RULES_LIST_SUCCESS)
          this.$store.dispatch(ACCOUNT_KEY_IOCS_SUCCESS)
          this.setTableMetaData(tableMetaData)
          this.isLoading = false
          this.tacticRecordsHandler(this.detectionsData.models)
          if (this.workloadCheck) {
            this.workloadList()
          } else if (this.cloudControlCheck) {
            this.cloudControlList()
          } else {
            this.allRec()
          }
        })
    },
    getDetectionByListOfAccountKeys (tableMetaData) {
      this.$store
        .dispatch(MULTIPLE_ACCOUNT_KEY_IOCS_REQ, {
          accountKeys: this.$route.query.accountKeys
        })
        .then(detections => {
          this.detectionsData = detections
          this.$store.dispatch(RULES_LIST_SUCCESS)
          this.$store.dispatch(ACCOUNT_KEY_IOCS_SUCCESS)
          this.setTableMetaData(tableMetaData)
          this.isLoading = false
          this.tacticRecordsHandler(this.detectionsData.models)
          if (this.workloadCheck) {
            this.workloadList()
          } else if (this.cloudControlCheck) {
            this.cloudControlList()
          } else {
            this.allRec()
          }
        })
    },
    callApi (tableMetaData) {
      if (this.rulesListReqStatus === 'saved' && this.agentListReqStatus === 'saved') {
        if (!this.$_.isEmpty(this.$route.query.integrationType)) {
          this.getDetectionByAlertAccountKey(tableMetaData)
        } else if (!this.$_.isEmpty(this.$route.query.accountKey)) {
          this.getDetectionByAccountKey(tableMetaData)
        } else if (!this.$_.isEmpty(this.$route.query.accountKeys)) {
          this.getDetectionByListOfAccountKeys(tableMetaData)
        }
      } else {
        let apiCalls = []
        if (this.rulesListReqStatus !== 'saved') {
          apiCalls.push(this.$store.dispatch(RULES_LIST_REQ))
        }
        if (this.agentListReqStatus !== 'saved') {
          apiCalls.push(this.$store.dispatch(AGENT_LIST_REQ))
        }
        this.isLoading = true
        Promise.all(apiCalls).then(
          values => {
            if (!this.$_.isEmpty(this.$route.query.integrationType)) {
              this.getDetectionByAlertAccountKey(tableMetaData)
            } else if (!this.$_.isEmpty(this.$route.query.accountKey)) {
              this.getDetectionByAccountKey(tableMetaData)
            } else if (!this.$_.isEmpty(this.$route.query.accountKeys)) {
              this.getDetectionByListOfAccountKeys(tableMetaData)
            }
          },
          errMsg => {
            this.isLoading = false
            console.log(errMsg.toString())
          }
        )
      }
    },
    setTableMetaData (tableMetaData) {
      this.detectionsData.searchTags = tableMetaData.searchTags
      this.detectionsData.currentPage = tableMetaData.activePage
    },
    workloadList () {
      this.selectedMitreAttack = ''
      this.cloudControlCheck = false
      this.detectionsData.resetFilteredObjectAndSearch()
      const filteredDetectionRecords = this.detectionsData.filterDataByProperty('cloudNative', 'false')
      this.updateTableQueryData()
      this.recordCountHandler()
      if (!this.workloadCheck) {
        this.tacticRecordsHandler(filteredDetectionRecords)
        this.workloadCheck = true
      }
    },
    allRec () {
      this.selectedMitreAttack = ''
      this.cloudControlCheck = false
      this.workloadCheck = false
      this.detectionsData.resetFilteredObjectAndSearch()
      let filteredDetectionRecords = this.detectionsData
      this.updateTableQueryData()
      this.recordCountHandler()
      this.tacticRecordsHandler(filteredDetectionRecords.models)
    },
    cloudControlList () {
      this.selectedMitreAttack = ''
      this.workloadCheck = false
      this.detectionsData.resetFilteredObjectAndSearch()
      let filteredDetectionRecords = this.detectionsData.filterDataByProperty('cloudNative', 'true')
      this.updateTableQueryData()
      this.recordCountHandler()
      if (!this.cloudControlCheck) {
        this.tacticRecordsHandler(filteredDetectionRecords)
        this.cloudControlCheck = true
      }
    },
    tacticRecordsHandler (records) {
      let credentialAccess = 0
      let impact = 0
      let lateralMovement = 0
      let discovery = 0
      let initialAccess = 0
      let persistences = 0
      let exflitration = 0
      let execution = 0
      let privEsclation = 0
      let defenseEvasion = 0
      let collection = 0
      let commandAndControl = 0
      let unknown = 0
      for (let rec of records) {
        if (rec.iocTactic === 'Credential Access') {
          credentialAccess = credentialAccess + 1
        } else if (rec.iocTactic === 'Impact') {
          impact = impact + 1
        } else if (rec.iocTactic === 'Lateral Movement') {
          lateralMovement = lateralMovement + 1
        } else if (rec.iocTactic === 'Discovery') {
          discovery = discovery + 1
        } else if (rec.iocTactic === 'Initial Access') {
          initialAccess = initialAccess + 1
        } else if (rec.iocTactic === 'Persistence') {
          persistences = persistences + 1
        } else if (rec.iocTactic === 'Exfiltration') {
          exflitration = exflitration + 1
        } else if (rec.iocTactic === 'Execution') {
          execution = execution + 1
        } else if (rec.iocTactic === 'Privilege Escalation') {
          privEsclation = privEsclation + 1
        } else if (rec.iocTactic === 'Defense Evasion') {
          defenseEvasion = defenseEvasion + 1
        } else if (rec.iocTactic === 'Collection') {
          collection = collection + 1
        } else if (rec.iocTactic === 'Command and Control') {
          commandAndControl = commandAndControl + 1
        } else {
          unknown = unknown + 1
        }
      }
      this.mitreAttackDetailsforTopHeader.credentialAccess = credentialAccess
      this.mitreAttackDetailsforTopHeader.impact = impact
      this.mitreAttackDetailsforTopHeader.lateralMovement = lateralMovement
      this.mitreAttackDetailsforTopHeader.discovery = discovery
      this.mitreAttackDetailsforTopHeader.initialAccess = initialAccess
      this.mitreAttackDetailsforTopHeader.persistences = persistences
      this.mitreAttackDetailsforTopHeader.exflitration = exflitration
      this.mitreAttackDetailsforTopHeader.execution = execution
      this.mitreAttackDetailsforTopHeader.defenseEvasion = defenseEvasion
      this.mitreAttackDetailsforTopHeader.collection = collection
      this.mitreAttackDetailsforTopHeader.commandAndControl = commandAndControl
      this.mitreAttackDetailsforTopHeader.unknown = unknown
      this.mitreAttackDetailsforTopHeader.privEsclation = privEsclation

      this.tacticRecords = [
        {
          title: "Credential Access",
          value: this.mitreAttackDetailsforTopHeader.credentialAccess
        },
        {
          title: "Defense Evasion",
          value: this.mitreAttackDetailsforTopHeader.defenseEvasion
        },
        {
          title: "Impact",
          value: this.mitreAttackDetailsforTopHeader.impact
        },
        {
          title: "Lateral Movement",
          value: this.mitreAttackDetailsforTopHeader.lateralMovement
        },
        {
          title: "Discovery",
          value: this.mitreAttackDetailsforTopHeader.discovery
        },
        {
          title: "Initial Access",
          value: this.mitreAttackDetailsforTopHeader.initialAccess
        },
        {
          title: "Persistence",
          value: this.mitreAttackDetailsforTopHeader.persistences
        },
        {
          title: "Exfiltration",
          value: this.mitreAttackDetailsforTopHeader.exflitration
        },
        {
          title: "Execution",
          value: this.mitreAttackDetailsforTopHeader.execution
        },
        {
          title: "Privilege Escalation",
          value: this.mitreAttackDetailsforTopHeader.privEsclation
        },
        {
          title: "Collection",
          value: this.mitreAttackDetailsforTopHeader.collection
        },
        {
          title: "Command and Control",
          value: this.mitreAttackDetailsforTopHeader.commandAndControl
        }
      ]
    },
    intersection (selectedIoc) {
      if (this.cloudControlCheck) {
        this.cloudControlList()
        if (this.toggleCheck && (this.currentIoc !== selectedIoc)) {
          this.mitreAttackSelectionHandler(selectedIoc)
          this.currentIoc = selectedIoc
        } else if (this.toggleCheck) {
          this.cloudControlList()
          this.toggleCheck = !this.toggleCheck
        } else {
          this.mitreAttackSelectionHandler(selectedIoc)
          this.currentIoc = selectedIoc
          this.toggleCheck = !this.toggleCheck
        }
        this.recordCountHandler()
      } else if (this.workloadCheck) {
        this.workloadList()
        if (this.toggleCheck && (this.currentIoc !== selectedIoc)) {
          this.mitreAttackSelectionHandler(selectedIoc)
          this.currentIoc = selectedIoc
        } else if (this.toggleCheck) {
          this.workloadList()
          this.toggleCheck = !this.toggleCheck
        } else {
          this.mitreAttackSelectionHandler(selectedIoc)
          this.currentIoc = selectedIoc
          this.toggleCheck = !this.toggleCheck
        }
        this.recordCountHandler()
      } else {
        this.allRec()
        if (this.toggleCheck && (this.currentIoc !== selectedIoc)) {
          this.mitreAttackSelectionHandler(selectedIoc)
          this.currentIoc = selectedIoc
        } else if (this.toggleCheck) {
          this.allRec()
          this.toggleCheck = !this.toggleCheck
        } else {
          this.mitreAttackSelectionHandler(selectedIoc)
          this.currentIoc = selectedIoc
          this.toggleCheck = !this.toggleCheck
        }
        this.recordCountHandler()
      }
    },
    mitreAttackSelectionHandler (selectedIoc) {
      this.selectedMitreAttack = selectedIoc
      this.currentSelectedMitreAttack = selectedIoc
      this.detectionsData.filterDataByProperty('iocTactic', selectedIoc)
      this.updateTableQueryData()
      this.recordCountHandler()
    },
    getIntegrationAccountTitle (type) {
      switch (type) {
        case 'CONFLUERA':
          return 'Confluera'
        case 'CARBONBLACK':
          return 'Carbon Black'
        case 'ALB':
          return 'AWS Load Balancer'
        case 'GUARDDUTY':
          return 'Guard Duty'
        case 'PAN':
          return 'Palo Alto Networks'
        case 'TRENDMICRO':
          return 'TrendMicro'
        case 'SNYK':
          return 'Snyk'
        case 'RDS':
          return 'AWS RDS'
      }
    }
  },
  watch: {},
  beforeMount () {
    this.breadcrumbs = this.threatBreadCrumb
  },
  computed: {
    isIocDetectionsLoading () {
      return this.accountKeyIocsReqStatus === 'loading'
    },
    isIocDetailsLoading () {
      return this.iocDetailsReqStatus === 'loading'
    },
    threatBreadCrumb () {
      return [
        { title: 'Threats' },
        { title: 'Detections', to: '/detections' },
        { title: this.$route.query.nickName || this.$route.query.accountKey }
      ]
    },
    ...mapGetters([
      'accountKeyIocsReqStatus',
      'accountKeyIocsList',
      'rulesListReqStatus',
      'agentListReqStatus',
      'mitreTacticListReqStatus',
      'iocDetailsReqStatus',
      'insightsEnabled',
      'detectionPreferences',
      'userProfile',
      'userPref'
    ])
  },
  components: {
    PageHeaders,
    ActionTableElement,
    TableToolbar,
    AsideSidebar,
    ProcessLineageGraph,
    IocMultiEventDetails
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.process-lineage-details {
  >>> .aside-sidebar {
    width: 50% !important;
  }
}

.heading {
  .fal {
    background: #e07373;
    border-radius: 50%;
  }

  .box {
    min-width: 25px;

    .score {
      color: var(--gray-600);
    }
  }

  .box.score {
    min-width: 50px;
  }
}

.search-reset {
  line-height: 36px;

  p {
    display: inline;
  }

  .icon-text-button {
    background: var(--denim-500);
    padding: 5px 10px;
    vertical-align: middle;

    span {
      color: white;
    }

    .c-icon {
      margin-right: 0px !important;
    }
  }

  .helper-message {
    background: var(--denim-50);
    padding: 20px;
  }
}

.local-trailid {
  .material-icons {
    font-size: 14px;
    vertical-align: middle;
  }
}

>>> .add-search-tags-btn {
  display: none;
}

>>> .vue-tags-search-box {
  position: static !important;
}

>>> .search-box {
  padding: 18px 0px;
}

.tactic-records-container {
  box-sizing: border-box;
  height: 90px;
  width: 100px;
  border: 1px solid #D7DBE0;
  border-radius: 2px;
  margin-right: 12px;
  cursor:pointer;
}

.tactic-records-container-highligted {
  box-sizing: border-box;
  height: 90px;
  width: 100px;
  border: 2px solid #1377f0;
  border-radius: 2px;
  margin-right: 12px;
  cursor:pointer;
}

.tactic-records-container-highligted-workload {
  box-sizing: border-box;
  height: 90px;
  width: 100px;
  border: 2px solid #2DCB8B;
  border-radius: 2px;
  margin-right: 12px;
  cursor:pointer;
}

.tactic-records-container-highligted-cloudControl {
  box-sizing: border-box;
  height: 90px;
  width: 100px;
  border: 2px solid #B264DE;
  border-radius: 2px;
  margin-right: 12px;
  cursor:pointer;
}

.tact-records-title {
  margin-top:3px;
  height: 37px;
  width: 71px;
  color: #454B60;
  font-size: 12px;
  text-align: center;
  margin-left:9px;
  
} 

.tactic-records-value {
  height: 28px;
  width: auto;
  color: #1A90FA;
  font-size: 23px;
  font-weight: 600;
  text-align: center;
  margin-left:0px;
  margin-top:8px;
}

.ioc-tactic-list {
  display:flex;
  overflow-x: auto;
}

.mitre-attack-header {
  font-size: 12.5px;
  letter-spacing: 0.16px;
  color: #909399;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/views/detections/AccountKeyDetections.vue